import { render, staticRenderFns } from "./Quizzard.vue?vue&type=template&id=0b6b1ab5&scoped=true&"
import script from "./Quizzard.vue?vue&type=script&lang=js&"
export * from "./Quizzard.vue?vue&type=script&lang=js&"
import style0 from "./Quizzard.vue?vue&type=style&index=0&id=0b6b1ab5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b1ab5",
  null
  
)

export default component.exports